export interface TareaReporte {
  uuid: string;
  reporte: string;
  nombre?: string;
  tipo?: string;
  parametros: ParametroTarea[];
  tipoReporte?: TipoReporte;
  fechaEjecucion?: Date;
  usuario: string;
  estado?: string;
  resultado?: string;
}

export interface ParametroTarea {
  parametro: string;
  multipleValor: boolean;
  nombre?: string;
  alias?: string;
  valor?: string;
}

export enum TipoReporte {
  REPORTE = "REPORTE",
  MAPA = "MAPA",
  TABLERO = "TABLERO",
  BANCO_CONOCIMIENTO = "BANCO_CONOCIMIENTO",
}

export enum EstadosTareaReporte {
  PEND = "PEND",
  ENEJ = "ENEJ",
  FINA = "FINA",
  CANC = "CANC",
  FAIL = "FAIL"
}